import React, { useState } from "react";
import "../css/DonationForm.css";

const DonationForm = () => {
  const [campaign, setCampaign] = useState("smart-classroom");
  const [currency, setCurrency] = useState("INR");
  const [amount, setAmount] = useState("100");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [payVia, setPayVia] = useState("Nepal");

  const [showPopup, setShowPopup] = useState(false);
  const [txnId, setTxnId] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const currencySymbols = {
    INR: "₹",
    NPR: "Rs.",
    USD: "$",
  };

  const handleDonateClick = (e) => {
    e.preventDefault();

    if (!campaign) {
      alert("कृपया एक Campaign चुनें (Please select a campaign)");
      return;
    }
    if (!amount || parseFloat(amount) <= 0) {
      alert(
        "कृपया एक वैध राशि दर्ज करें (Please enter a valid amount greater than 0)",
      );
      return;
    }
    if (!fullName || !email || !mobile) {
      alert("कृपया सभी आवश्यक फ़ील्ड भरें (Please fill all required fields)");
      return;
    }

    setShowPopup(true);
  };

  const handleFinalSubmit = (e) => {
    e.preventDefault();
    if (!txnId.trim()) {
      alert(
        "कृपया भुगतान के बाद Transaction ID दर्ज करें (Please enter Transaction ID)",
      );
      return;
    }

    setIsSubmitted(true);
    setTimeout(() => {
      alert(`भुगतान विवरण सफलतापूर्वक सबmit हो गया! Txn ID: ${txnId}`);
      setShowPopup(false);
      setIsSubmitted(false);
      setTxnId("");
      setAmount("100");
      setFullName("");
      setEmail("");
      setMobile("");
    }, 1200);
  };

  return (
    <div className="donation-master-container">
      <div className="donation-main-card">
        {}
        <div className="donation-left-form">
          <form onSubmit={handleDonateClick}>
            {}
            <div className="form-group-block">
              <label className="input-field-label">
                Select Fundraising Campaign *
              </label>
              <select
                className="donation-custom-select font-bold-style"
                value={campaign}
                onChange={(e) => setCampaign(e.target.value)}
              >
                <option value="smart-classroom">
                  Intrest Free loan for Sahara Public Secondary School Nepal
                </option>
              </select>
            </div>

            {}
            <div className="form-group-block">
              <label className="input-field-label">
                Select Currency & Amount *
              </label>
              <div className="currency-amount-flex-row">
                <select
                  className="currency-dropdown-box"
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                >
                  <option value="INR">₹ (INR)</option>
                  <option value="NPR">Rs (NPR)</option>
                  <option value="USD">$ (USD)</option>
                </select>
                <input
                  type="number"
                  className="amount-input-box"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="100"
                  min="1"
                  required
                />
              </div>
            </div>

            {}
            <div className="form-group-block">
              <label className="input-field-label">Full Name *</label>
              <input
                type="text"
                className="donation-regular-input"
                placeholder="John Doe"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
              />
            </div>

            {}
            <div className="form-group-block">
              <label className="input-field-label">Email Address *</label>
              <input
                type="email"
                className="donation-regular-input"
                placeholder="john@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {}
            <div className="form-group-block">
              <label className="input-field-label">Mobile: *</label>
              <input
                type="text"
                className="donation-regular-input"
                placeholder="+977 *******08"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                required
              />
            </div>

            {}
            <div className="form-group-block">
              <label className="input-field-label">Pay Via</label>
              <div className="payvia-triple-toggle">
                <button
                  type="button"
                  className={`btn btn-primary ${payVia === "PayPal" ? "payvia-active" : ""}`}
                  onClick={() => {
                    setPayVia("PayPal");
                    setCurrency("USD");
                  }}
                >
                  PayPal
                </button>
                <button
                  type="button"
                  className={`btn btn-primary ${payVia === "Nepal" ? "payvia-active" : ""}`}
                  onClick={() => {
                    setPayVia("Nepal");
                    setCurrency("NPR");
                  }}
                >
                  Nepal
                </button>
                <button
                  type="button"
                  className={`btn btn-primary ${payVia === "Indian" ? "payvia-active" : ""}`}
                  onClick={() => {
                    setPayVia("Indian");
                    setCurrency("INR");
                  }}
                >
                  Indian
                </button>
              </div>
            </div>

         <button 
  type="submit" 
  className="master-action-donate-btn"
>
  DONATE {currencySymbols[currency]} {amount || 0}
</button>
          </form>
        </div>

        {}
        <div className="donation-right-info-panel">
          <div className="info-yellow-card-border-box">
            <h3 className="why-title-text">
              Why Sahara Public Secondary School?
            </h3>

            <div className="why-bullet-row">
              <span className="bullet-check-box">✅</span>
              <p className="bullet-desc-string">100% Transparency</p>
            </div>

            <div className="why-bullet-row">
              <span className="bullet-check-box">✅</span>
              <p className="bullet-desc-string">Direct Student Support</p>
            </div>

            <div className="why-bullet-row">
              <span className="bullet-check-box">✅</span>
              <p className="bullet-desc-string">Secure Encrypted Payment</p>
            </div>

            <p className="why-quote-italic-block">
              "Education is the most powerful weapon which you can use to change
              the world."
            </p>
          </div>
        </div>
      </div>

      {}
      {showPopup && (
        <div className="payment-popup-backdrop-blur">
          <div className="payment-modal-box-window view-pop-animation">
            <div className="modal-header-flex">
              <h3>Secure Payment ({payVia} Gateway)</h3>
              <button
                className="btn"
                onClick={() => setShowPopup(false)}
              >
                ×
              </button>
            </div>

            <div className="modal-scrollable-body">
              <p className="payment-alert-top-message">
                Please use the specific <b>{payVia}</b> details below to
                complete your payment of{" "}
                <b>
                  {currencySymbols[currency]} {amount}
                </b>
                .
              </p>

              {}
              {payVia === "Nepal" && (
                <>
                  <div className="qr-wrapper-layout-card">
                    <div
                      className="mock-qr-graphic"
                      style={{ height: "auto", padding: "10px" }}
                    >
                      <img
                        src="../images/nppay.jpeg"
                        alt="Nepal eSewa / Fonepay QR"
                        style={{
                          width: "150px",
                          height: "150px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <p className="qr-caption-hint-string">
                      Scan via eSewa / Khalti / FonePay (Nepal)
                    </p>
                  </div>

                  <div className="payment-details-text-card">
                    <div className="detail-row-item">
                      <span>
                        <b>Bank Name:</b>
                      </span>
                      <span>Nepal Investment Mega Bank Ltd.</span>
                    </div>
                    <div className="detail-row-item">
                      <span>
                        <b>Account Name:</b>
                      </span>
                      <span>Sahara Public School</span>
                    </div>
                    <div className="detail-row-item">
                      <span>
                        <b>Account No:</b>
                      </span>
                      <span className="selectable-code-text">
                        03402050250610
                      </span>
                    </div>
                    <div className="detail-row-item">
                      <span>
                        <b>IFSC Code:</b>
                      </span>
                      <span>NIBLNPKTXXX </span>
                    </div>
                    <div className="detail-row-item">
                      <span>
                        <b>Branch:</b>
                      </span>
                      <span>Krishnanagar </span>
                    </div>
                  </div>
                </>
              )}

              {}
              {payVia === "Indian" && (
                <>
                  <div className="qr-wrapper-layout-card">
                    <div
                      className="mock-qr-graphic"
                      style={{ height: "auto", padding: "10px" }}
                    >
                      <img
                        src="../images/nepalpay.jpeg"
                        alt="Indian UPI QR"
                        style={{
                          width: "150px",
                          height: "150px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <p className="qr-caption-hint-string">
                      Scan via GPay / PhonePe / Paytm (India)
                    </p>
                  </div>

                  <div className="payment-details-text-card">
                    <div className="detail-row-item">
                      <span>
                        <b>UPI ID:</b>
                      </span>
                      <span className="selectable-code-text">
                        saharaschool@upi
                      </span>
                    </div>
                    <hr className="modal-divider-line" />
                    <div className="detail-row-item">
                      <span>
                        <b>Bank Name:</b>
                      </span>
                      <span>State Bank of India (SBI)</span>
                    </div>
                    <div className="detail-row-item">
                      <span>
                        <b>Account Name:</b>
                      </span>
                      <span>Sahara Public School Trust</span>
                    </div>
                    <div className="detail-row-item">
                      <span>
                        <b>Account No:</b>
                      </span>
                      <span className="selectable-code-text">41234567890</span>
                    </div>
                    <div className="detail-row-item">
                      <span>
                        <b>IFSC Code:</b>
                      </span>
                      <span className="selectable-code-text">SBIN0001234</span>
                    </div>
                  </div>
                </>
              )}

              {}
              {payVia === "PayPal" && (
                <>
                  <div className="qr-wrapper-layout-card">
                    <div
                      className="mock-qr-graphic"
                      style={{ height: "auto", padding: "10px" }}
                    >
                      <img
                        src="../images/ppay.jpeg"
                        alt="Indian UPI QR"
                        style={{
                          width: "150px",
                          height: "150px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <p className="qr-caption-hint-string">
                      Scan via GPay / PhonePe / Paytm (India)
                    </p>
                  </div>
                  <div
                    className="payment-details-text-card"
                    style={{ marginTop: "15px", backgroundColor: "#f0f7ff" }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        padding: "10px 0",
                        fontSize: "2.5rem",
                      }}
                    >
                      💳
                    </div>
                    <h4
                      style={{
                        textAlign: "center",
                        color: "#004a99",
                        marginBottom: "10px",
                      }}
                    >
                      International PayPal Transfer
                    </h4>
                    <p
                      style={{
                        fontSize: "0.9rem",
                        color: "#555",
                        textAlign: "center",
                        marginBottom: "15px",
                      }}
                    >
                      Please send your donation amount directly to our official
                      institutional PayPal account email.
                    </p>
                    <div
                      className="detail-row-item"
                      style={{ justifyContent: "center", gap: "10px" }}
                    >
                      <span>
                        <b>PayPal Email:</b>
                      </span>
                      <span
                        className="selectable-code-text"
                        style={{ fontSize: "1.05rem", color: "#004a99" }}
                      >
                        paypal@sahara.edu.np
                      </span>
                    </div>
                  </div>
                </>
              )}

              {}
              <form
                onSubmit={handleFinalSubmit}
                className="modal-verification-form-wrapper"
              >
                <div className="form-group-block">
                  <label className="input-field-label text-dark-color">
                    {payVia === "PayPal"
                      ? "Enter PayPal Transaction ID *"
                      : "Enter Transaction ID / Reference No. *"}
                  </label>
                  <input
                    type="text"
                    className="donation-regular-input highlight-input-border"
                    placeholder="e.g. TXN1234567890"
                    value={txnId}
                    onChange={(e) => setTxnId(e.target.value)}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isSubmitted}
                >
                  {isSubmitted
                    ? "Verifying Transaction..."
                    : "SUBMIT PAYMENT DETAILS"}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DonationForm;
